/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { SolutionStatusOnlyDtoModel, SolutionStatusOnlyDtoModelType } from "./SolutionStatusOnlyDtoModel"
import { SolutionStatusOnlyDtoModelSelector } from "./SolutionStatusOnlyDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  pendingSolution: SolutionStatusOnlyDtoModelType;
}

/**
 * ProjectRouteStopSchedulingDtoBase
 * auto generated base class for the model ProjectRouteStopSchedulingDtoModel.
 *
 * Route scheduling a stop
 */
export const ProjectRouteStopSchedulingDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ProjectRouteStopSchedulingDto')
  .props({
    __typename: types.optional(types.literal("ProjectRouteStopSchedulingDto"), "ProjectRouteStopSchedulingDto"),
    pendingSolution: types.union(types.undefined, MSTGQLRef(types.late((): any => SolutionStatusOnlyDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ProjectRouteStopSchedulingDtoModelSelector extends QueryBuilder {
  pendingSolution(builder: string | SolutionStatusOnlyDtoModelSelector | ((selector: SolutionStatusOnlyDtoModelSelector) => SolutionStatusOnlyDtoModelSelector) | undefined) { return this.__child(`pendingSolution`, SolutionStatusOnlyDtoModelSelector, builder) }
}
export function selectFromProjectRouteStopSchedulingDto() {
  return new ProjectRouteStopSchedulingDtoModelSelector()
}

export const projectRouteStopSchedulingDtoModelPrimitives = selectFromProjectRouteStopSchedulingDto()
